import React from 'react'
import PropTypes from 'prop-types'

/**
 * wrapper component
 * @param children
 * @returns {*}
 * @constructor
 */


class SwitchTime extends React.Component {

    render() {
        var children = this.props.children;

        return (
        <div>
            {children}
        </div>);
    }
}


SwitchTime.propTypes = {
    children: PropTypes.node.isRequired,
}

export default SwitchTime;